import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loadStore } from '../../../redux/modules/store';
import BrtIcon from './icone_spedizionieri/Brt';
import DhlIcon from './icone_spedizionieri/Dhl';
import FedexIcon from './icone_spedizionieri/Fedex';
import GlsIcon from './icone_spedizionieri/Gls';
import SdaIcon from './icone_spedizionieri/Sda';
import lightOrDark from '../SlickArrow/colorArrowFunction';

class Spedizionieri extends Component {
  componentDidMount() {
    this.props.loadStore();
  }

  render() {
    const isBackgroundLightOrDark = lightOrDark(this.props.background);
    const iconColor = isBackgroundLightOrDark === 'light' ? '#000' : '#fff';

    let shippingTypes = [
      {
        id: 0,
        name: 'BRT',
        icon: <BrtIcon color={iconColor} style={{ width: 40, height: 24 }} />,
        on: this.props.hasBrt,
      },

      {
        id: 1,
        name: 'DHL',
        icon: <DhlIcon color={iconColor} style={{ width: 40, height: 24 }} />,
        on: this.props.hasDhl,
      },

      {
        id: 2,
        name: 'FEDEX',
        icon: <FedexIcon color={iconColor} style={{ width: 40, height: 24 }} />,
        on: this.props.hasFedEx,
      },

      {
        id: 3,
        name: 'GLS',
        icon: <GlsIcon color={iconColor} style={{ width: 40, height: 24 }} />,
        on: this.props.hasGls,
      },

      {
        id: 4,
        name: 'SDA',
        icon: <SdaIcon color={iconColor} style={{ width: 40, height: 24 }} />,
        on: this.props.hasSda,
      },
    ];

    const shippingTypeList = shippingTypes
      .filter(item => !!item.on)
      .map(item => item.icon);

    return (
      <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap' }}>
        {shippingTypeList}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  hasBrt: state.store.data.funzionalita.allowBrtLogo,
  hasDhl: state.store.data.funzionalita.allowDhlLogo,
  hasFedEx: state.store.data.funzionalita.allowFedexLogo,
  hasGls: state.store.data.funzionalita.allowGlsLogo,
  hasSda: state.store.data.funzionalita.allowSdaLogo,
});

// export default Spedizionieri;
export default connect(mapStateToProps, { loadStore })(Spedizionieri);
